import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import {
  deleteTemplate,
  getTemplateListings,
  createListingTemplates,
  getCategoriesWithInheritedAttributesByCategoryId,
  updateListingTemplates,
} from "./services";

function* __GET_TEMPLATES(action) {
  try {
    var payload = {
      templates: [],
    };
    const res = yield getTemplateListings();
    const data = res?.data;
    payload.templates = data?.templates;
    yield put(actions.create_listings_success(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.create_listings_fail({ error: errorMessage }));
  }
}

export function* templatesList() {
  yield takeLatest(actions.GET_TEMPLATES, __GET_TEMPLATES);
}

function* __CREATE_LISTING_TEMPLATES(action) {
  try {
    let payload = action.payload.data;
    const res = yield createListingTemplates(payload);
    if (res) {
      action.payload.success(payload);
    }
    // yield put(actions.response_success(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(e);
    yield put(actions.create_listings_fail({ error: errorMessage }));
  }
}

export function* createTemplatesList() {
  yield takeLatest(actions.CREATE_TEMPLATES, __CREATE_LISTING_TEMPLATES);
}

function* __CATEGORIES(action) {
  try {
    var payload = {
      // categories: [],
    };
    const res = yield getCategoriesWithInheritedAttributesByCategoryId();
    console.log(res, "response in saga");
    const data = res?.data;
    payload = data?.resource?.sub_categories;
    yield put(actions.CategoriesGetByIDSuccess(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.CategoriesGetByIDFailure({ error: errorMessage }));
  }
}

export function* categoriesByID() {
  yield takeLatest(actions.GET_CATEGORIES, __CATEGORIES);
}
function* __DELETE_TEMPLATE(action) {
  // alert(action.payload.template_id);
  try {
    // let payload = action.payload.template_id;
    const res = yield deleteTemplate(action.payload.template_id);
    const data = res?.data;

    yield put(actions.get_TemplateListings());
    action.payload.success(data);
  } catch (e) {
    console.log({ e });
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

export function* delTemplate() {
  yield takeLatest(actions.DELETE_TEMPLATE, __DELETE_TEMPLATE);
}

//edit templates

function* __UPDATE_LISTING_TEMPLATES(action) {
  try {
    let payload = action.payload.data;
    const res = yield updateListingTemplates(payload.id);
    if (res) {
      action.payload.success(payload);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
    yield put(actions.create_listings_fail({ error: errorMessage }));
  }
}

export function* updateTemplatesList() {
  yield takeLatest(actions.UPDATE_TEMPLATES, __UPDATE_LISTING_TEMPLATES);
}
